module.exports = __webpack_public_path__ + "static/media/workingmemory-numbers-8.aed27cae.mp3";